import React from "react";
import { Lock, Users, Globe, Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import styles from "./VisibilitySelector.module.css";

const VISIBILITY_OPTIONS = [
  {
    value: "private",
    icon: Lock,
    titleKey: "records.editor.visibility.options.private.title",
    titleDefault: "Private",
    descriptionKey: "records.editor.visibility.options.private.description",
    descriptionDefault: "Only you can see this",
  },
  {
    value: "friends",
    icon: Users,
    titleKey: "records.editor.visibility.options.friends.title",
    titleDefault: "Friends",
    descriptionKey: "records.editor.visibility.options.friends.description",
    descriptionDefault: "Your friends can see this",
  },
  {
    value: "public",
    icon: Globe,
    titleKey: "records.editor.visibility.options.public.title",
    titleDefault: "Public",
    descriptionKey: "records.editor.visibility.options.public.description",
    descriptionDefault: "Anyone can see this",
  },
];

export default function VisibilitySelector({ visibility, onUpdate }) {
  const { t } = useTranslation();

  const handleSelect = (value) => {
    onUpdate(value);

    // Visual feedback for public selection
    if (value === "public") {
      // TODO: Show warning animation or toast
    }
  };

  return (
    <div className={styles.section}>
      <label className={styles.label}>
        {t("records.editor.visibility.label", "Visibility")}
      </label>

      <div className={styles.options}>
        {VISIBILITY_OPTIONS.map((option) => {
          const Icon = option.icon;
          const title = t(option.titleKey, option.titleDefault);
          const description = t(option.descriptionKey, option.descriptionDefault);
          return (
            <button
              key={option.value}
              className={`${styles.option} ${
                visibility === option.value ? styles.active : ""
              }`}
              onClick={() => handleSelect(option.value)}
              aria-pressed={visibility === option.value}
              data-visibility={option.value}
              type="button"
            >
              <div className={styles.iconWrapper}>
                <Icon className={styles.icon} size={20} />
              </div>

              <div className={styles.content}>
                <div className={styles.title}>{title}</div>
                <div className={styles.description}>{description}</div>
              </div>

              {visibility === option.value && (
                <div className={styles.checkmark}>
                  <Check size={16} />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
